import { media } from 'common/src/designSystem/components/stitches';
import { useMediaQuery } from './useMediaQuery';

export function useMobileQuery() {
    return useMediaQuery(media.mobile);
}
